import '@onereach/styles/main-v3.css';

import { createApp } from 'vue';

import App from '@/App.vue';
import i18n from '@/i18n';
import router from '@/router';
import SentryApi from '@/sentry';
import createPinia from '@/stores';

import { can, canNot } from './directives/can';

const app = createApp(App);

app.directive('can', can);
app.directive('can-not', canNot);

app.use(i18n);
app.use(createPinia());
app.use(router);

SentryApi.init(app, router);

app.mount('#app');
